import { create } from 'zustand';

interface IleaveTrackerData {
  status: string;
  duration: number
  id: any;
}

interface UIState {
  isSidebarOpen: boolean;
  toggleSidebar: () => void;
  leaveTrackerModal: boolean;
  leaveTrackerData: IleaveTrackerData | null;
  showLeaveTrackerModal: (data: {
    status: string;
    duration: number;
    id: any;
  }) => void;
  closeLeaveTrackerModal: () => void;
}

const useUIStore = create<UIState>((set) => ({
  isSidebarOpen: true,
  toggleSidebar: () => set((state) => ({ isSidebarOpen: !state.isSidebarOpen })),
  leaveTrackerModal: false,
  leaveTrackerData: {
    status: "",
    duration: 0,
    id: null
  },
  showLeaveTrackerModal: (data) => set(() => ({ leaveTrackerModal: true, leaveTrackerData: data })),
  closeLeaveTrackerModal: () => set(() => ({ leaveTrackerModal: false, leaveTrackerData: null })),

}));

export default useUIStore;